// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .transaction-item{border-bottom:1px solid #f2f2f2}", ""]);
// Exports
module.exports = exports;
